function loadView(view) {
  return () => import(/* webpackChunkName: "view-[request]" */ `@/components/${view}.vue`)
}

// Tienda
export default [
  {
    path: 'bets',
    name: 'Bets',
    component: loadView('Back/Bet/Home')
  },
  {
    path: 'bets/create',
    name: 'BetsCreate',
    component: loadView('Back/Bet/CreateOrEdit')
  },
  {
    path: 'bets/:betId/edit',
    name: 'BetsEdit',
    component: loadView('Back/Bet/CreateOrEdit')
  },
  {
    path: 'bets/:betId/confirm-results',
    name: 'BetsConfirm',
    component: loadView('Back/Bet/BetsConfirm')
  }
]
